module.exports = "9d2e79d48b617b95f9b1d9001aaa9d8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/blank.png
// module id = 64
// module chunks = 0